/**
 * Custom navigation system.
 *
 * Desktop: an inline top nav where each parent item opens its own
 *          left off-canvas drawer (one drawer per category).
 * Mobile:  a single accordion drawer (expand/collapse in place).
 *
 * Kept independent of Dawn's MenuDrawer: the accordion toggles are
 * <div role="button"> (Dawn only binds <summary> / <button>), and the
 * category drawers are moved to <body> so a transformed sticky header
 * can never become their containing block.
 */
(function () {
  'use strict';

  var body = document.body;

  /* ------------------------------------------------------------------ */
  /* Desktop — category off-canvas drawers                              */
  /* ------------------------------------------------------------------ */
  var host = document.querySelector('.cat-drawers');
  if (host && host.parentElement !== body) body.appendChild(host);

  var overlay = host ? host.querySelector('.cat-drawer-overlay') : null;
  var drawers = host ? host.querySelectorAll('.cat-drawer') : [];
  var triggers = document.querySelectorAll('[data-cat-trigger]');

  function closeCatDrawers() {
    for (var i = 0; i < drawers.length; i++) {
      drawers[i].classList.remove('is-open');
      drawers[i].setAttribute('aria-hidden', 'true');
    }
    for (var t = 0; t < triggers.length; t++) {
      triggers[t].setAttribute('aria-expanded', 'false');
    }
    if (overlay) overlay.classList.remove('is-visible');
    body.classList.remove('cat-drawer-open');
  }

  function openCatDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    var wasOpen = drawer.classList.contains('is-open');
    closeCatDrawers();
    if (wasOpen) return; // second click on the same trigger closes it

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    var trigger = document.querySelector('[data-cat-trigger="' + id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (overlay) overlay.classList.add('is-visible');
    body.classList.add('cat-drawer-open');

    var firstLink = drawer.querySelector('a, button');
    if (firstLink) firstLink.focus({ preventScroll: true });
  }

  for (var i = 0; i < triggers.length; i++) {
    (function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openCatDrawer(trigger.getAttribute('data-cat-trigger'));
      });
    })(triggers[i]);
  }

  if (overlay) overlay.addEventListener('click', closeCatDrawers);

  var closers = document.querySelectorAll('.cat-drawer__close');
  for (var c = 0; c < closers.length; c++) {
    closers[c].addEventListener('click', closeCatDrawers);
  }

  /* ------------------------------------------------------------------ */
  /* Mobile — accordion                                                 */
  /* ------------------------------------------------------------------ */
  function toggleAccordion(toggle) {
    var item = toggle.closest('.acc__item');
    if (!item) return;
    var open = item.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  var accToggles = document.querySelectorAll('.acc__toggle[role="button"]');
  for (var a = 0; a < accToggles.length; a++) {
    (function (toggle) {
      toggle.addEventListener('click', function () {
        toggleAccordion(toggle);
      });
      toggle.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          toggleAccordion(toggle);
        }
      });
    })(accToggles[a]);
  }

  /* Mobile drawer close (X) — reuse Dawn's drawer close via its summary */
  var mobileClosers = document.querySelectorAll('.mobile-nav__close');
  function closeMobileDrawer() {
    var summary = document.querySelector('#Details-menu-drawer-container > summary');
    var details = document.getElementById('Details-menu-drawer-container');
    if (summary && details && details.hasAttribute('open')) summary.click();
  }
  for (var m = 0; m < mobileClosers.length; m++) {
    mobileClosers[m].addEventListener('click', closeMobileDrawer);
    mobileClosers[m].addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        closeMobileDrawer();
      }
    });
  }

  /* Esc closes the desktop drawers */
  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') closeCatDrawers();
  });
})();
